import { gql } from 'graphql-request'

export const GET_USERS_GIFTS_PACKAGES_BY_USER_ID = gql`
  query GET_USERS_GIFTS_PACKAGES_BY_USER_ID($take: Int, $skip: Int) {
    getUsersGiftsPackagesByMyUserId(take: $take, skip: $skip) {
      error
      status
      totalPages
      data {
        id
        giftId
        userId
        quantity
        gift {
          id
          name
          description
          value
          allowedCombos
          imgGift
          isGiftQuick
          isOpenModal
          animationSpeedCenter
          animationSpeedSeat
          animationMediaGift
          animationAlphaLayoutPosition
        }
      }
    }
  }
`
